import { Ml_Log_Event, Ml_Log_Status } from '@generated/graphql';
import { Status } from 'components/common';
import { LOG_EVENT, LOG_STATUS } from 'constants/logs';
import dayjs from 'dayjs';
import { TableColumn } from 'layout/TableLayout/types';
import { LogListData } from '../types';

const LOG_LIST_TABLE: TableColumn<LogListData>[] = [
  {
    title: 'Дата создания',
    render: (data) => dayjs(data.createdAt).format('DD.MM.YYYY'),
    name: 'createdAt',
  },
  {
    title: 'Тип',
    render: (data) => {
      return <Status<Ml_Log_Event> status={data.event} statusDetails={LOG_EVENT} />;
    },
    name: 'event',
  },
  {
    title: 'Статус',
    render: (data) => {
      return <Status<Ml_Log_Status> status={data.status} statusDetails={LOG_STATUS} />;
    },
    name: 'status',
  },
  {
    title: 'Текст ошибки',
    render: (data) => data.error || '',
    name: 'error',
  },
  {
    title: 'ID компании',
    render: (data) => data.company?.id || '',
    name: 'companyId',
  },
  {
    title: 'Название компании',
    render: (data) => data.company?.shortName || '',
    name: 'companyName',
  },
  {
    title: 'ID карты компетенций',
    render: (data) => data.competencyMapId || '',
    name: 'competencyMapId',
  },
  {
    title: 'ID навыка',
    render: (data) => data.skillId || '',
    name: 'skillId',
  },
  {
    title: 'ID тестирования',
    render: (data) => data.trialId || '',
    name: 'trialId',
  },
  {
    title: 'ID ответа',
    render: (data) => data.trialAnswerId || '',
    name: 'trialAnswerId',
  },
  {
    title: 'ID оценки CV',
    render: (data) => data.cvCheckId || '',
    name: 'cvCheckId',
  },
];

export default LOG_LIST_TABLE;
